var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Ghdk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.115 22.68V16.095C37.115 14.865 36.185 13.47 35.03 13.005L26.675 9.58498C24.8 8.81998 22.685 8.81998 20.81 9.58498L12.455 13.005C11.315 13.47 10.385 14.865 10.385 16.095V22.68C10.385 30.015 15.71 36.885 22.985 38.895C23.48 39.03 24.02 39.03 24.515 38.895C31.79 36.885 37.115 30.015 37.115 22.68Z",
    fill: "url(#paint0_linear_48_1419)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 25.5C17.3358 25.5 17 25.1642 17 24.75V23.2617C17 22.8475 17.3358 22.5117 17.75 22.5117H21.232C21.6463 22.5117 21.982 22.1759 21.982 21.7617V18C21.982 17.5858 22.3178 17.25 22.732 17.25H24.7541C25.1684 17.25 25.5041 17.5858 25.5041 18V21.7617C25.5041 22.1759 25.8399 22.5117 26.2541 22.5117H29.75C30.1642 22.5117 30.5 22.8475 30.5 23.2617V24.75C30.5 25.1642 30.1642 25.5 29.75 25.5H26.2541C25.8399 25.5 25.5041 25.8358 25.5041 26.25V30C25.5041 30.4142 25.1684 30.75 24.7541 30.75H22.732C22.3178 30.75 21.982 30.4142 21.982 30V26.25C21.982 25.8358 21.6463 25.5 21.232 25.5H17.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_1419",
    x1: 23.75,
    y1: 9.01123,
    x2: 23.75,
    y2: 38.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Ghdk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2ghdk.482ea322.svg";
export { ForwardRef as ReactComponent };